import { render, staticRenderFns } from "./MarsNotice.vue?vue&type=template&id=fb87b9aa&scoped=true&"
import script from "./MarsNotice.vue?vue&type=script&lang=js&"
export * from "./MarsNotice.vue?vue&type=script&lang=js&"
import style0 from "./MarsNotice.vue?vue&type=style&index=0&id=fb87b9aa&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb87b9aa",
  null
  
)

export default component.exports